import { queueRequest, cacheData, getCachedData } from './offlineDb';
import { store } from '../redux/store';

export async function safeFetch(url, options = {}, cacheKey = null) {
  const state = store.getState?.();
  const isOnline = state?.server?.isOnline ?? true;
  const isPost = options?.method?.toUpperCase?.() === 'POST';
  const hasAuthHeader = options?.headers?.Authorization;

  const offlineFallback = async (reason) => {
    console.warn('[SAFE_FETCH] Offline o errore:', reason, url);
    const userMessage = reason === 'offline'
      ? 'Connessione assente. Controlla la rete e riprova.'
      : 'Impossibile contattare il server. Controlla la connessione e riprova.';

    if (cacheKey) {
      const cachedData = await getCachedData(cacheKey);
      if (cachedData) {
        console.log(`[SAFE_FETCH] Recuperati dati da cache per ${cacheKey}`);
        return {
          ok: true,
          status: 200,
          offline: true,
          json: async () => cachedData,
          text: async () => JSON.stringify(cachedData),
        };
      }
    }

    if (!isOnline && isPost && hasAuthHeader) {
      await queueRequest({
        url,
        options,
        timestamp: Date.now()
      });
    }

    return {
      ok: false,
      status: 0,
      offline: true,
      json: async () => ({ error: userMessage, message: userMessage }),
      text: async () => userMessage,
    };
  };

  if (!isOnline) {
    console.log(`[SAFE_FETCH] Offline. Tentativo di recupero da cache per ${cacheKey || url}`);
    return offlineFallback('offline');
  }

  try {
    const res = await fetch(url, options);

    if (!res.ok) {
      if (res.status === 401) {
        console.warn(`[SAFE_FETCH] Errore 401: Non autorizzato. Cache NON usata per ${url}`);
        return {
          ok: false,
          status: 401,
          json: async () => ({ error: 'Sessione non valida o scaduta. Effettua nuovamente l\'accesso.' }),
          text: async () => 'Sessione non valida o scaduta. Effettua nuovamente l\'accesso.',
        };
      } else if (res.status === 403) {
        console.warn(`[SAFE_FETCH] Errore 403: accesso negato. Cache NON usata per ${url}`);
        return {
          ok: false,
          status: 403,
          json: async () => ({ error: 'Non hai i permessi necessari per eseguire questa operazione.' }),
          text: async () => 'Non hai i permessi necessari per eseguire questa operazione.',
        };
      } else {
        // ── Return the real response so callers can read the actual error body
        // (e.g. 400 validation/unique constraint errors from the backend)
        console.warn(`[SAFE_FETCH] Errore HTTP: ${res.status} per ${url}.`);
        return res;
      }
    }

    const clonedRes = res.clone();
    let data = null;
    try {
      const text = await clonedRes.text();
      data = text ? JSON.parse(text) : null;
    } catch (e) {
      console.warn('[SAFE_FETCH] Nessun JSON da parsare o errore nel parsing:', e);
    }

    if (cacheKey && data) {
      await cacheData(cacheKey, data);
    }

    return res;
  } catch (err) {
    console.error('[SAFE_FETCH] Errore di rete:', err, url);
    return offlineFallback(err);
  }
}
